import { render } from "./SeniorSuperlative.vue?vue&type=template&id=46d03c84&scoped=true"
import script from "./SeniorSuperlative.vue?vue&type=script&lang=js"
export * from "./SeniorSuperlative.vue?vue&type=script&lang=js"

import "./SeniorSuperlative.vue?vue&type=style&index=0&id=46d03c84&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d03c84"]])

export default __exports__